import { SimpleUserOption } from "./simple-user-option";
import { TemplateConfigFieldItem } from "./template-config-field-item";

export class TemplateConfigItem {
    ID?: number;
    OrgID?: number;
    Name?: string;
    TypeID: number = 1; // Default to ASM type since it's the only type allowed
    TypeName?: string;
    Notes?: string;
    CreateDate?: string;
    CreatedBy?: SimpleUserOption;
    LastModified?: string;
    ModifiedBy?: SimpleUserOption;
    Enabled?: boolean;
    FieldItems?: TemplateConfigFieldItem[];
}

export enum TemplateConfigType {
    ASM = 1
}